/**
 * @ngdoc service
 * @name home.service:homeManagerSvc
 * @requires $q
 * @requires $window
 * @requires ItxScreenSizeSvc
 * @description
 * Home Selector Service
 */
(function () {
    'use strict';

    angular.module('itxApp.home').service('homeManagerSvc', homeSelectorService);

    homeSelectorService.$inject = ['$q', 'ItxConfigurationSvc', 'ItxHeaderFct'];

    function homeSelectorService($q, ItxConfigurationSvc, ItxHeaderFct) {
        //FUNCTION DECLARATION
        var lastStoreJson;

        if (lastStoreJson) {
            lastStoreJson.section = ItxHeaderFct.getLastSection();
        }

        return {
            setWorldWideVariables: _setWorldWideVariables,

            validHomeParams: _validHomeParams,
            updateWorldWideInfo: _updateWorldWideInfo,
            getLastStore: _getLastStore,
            _lastStoreJson: lastStoreJson,
            saveLastStore: saveLastStore,
            removeLastStore: removeLastStore
        };

        function _getLastStore(fromWorldWide) {
            if (fromWorldWide) {
                lastStoreJson = JSON.parse(inditex.getLocalStorage('LAST_STORE_GEOBLOCKING'));
                if (!lastStoreJson) {
                    lastStoreJson = JSON.parse(inditex.getLocalStorage('LAST_STORE'));
                } else {
                    lastStoreJson.isGeoblocking = lastStoreJson.saveGeoblockingStore;
                }
            } else {
                var isgeoBlockingEnabled = ItxConfigurationSvc.get('geoblockingEnabled');
                if (isgeoBlockingEnabled) {
                    lastStoreJson = JSON.parse(inditex.getLocalStorage('LAST_STORE_GEOBLOCKING'));
                    if (lastStoreJson) {
                        lastStoreJson.isGeoblocking = lastStoreJson.saveGeoblockingStore;
                    }
                } else {
                    lastStoreJson = JSON.parse(inditex.getLocalStorage('LAST_STORE'));
                }
            }
            return lastStoreJson;
        }

        /**
         * @ngdoc method
         * @name validHomeParams
         * @methodOf  home.service:homeManagerSvc
         * @description checks if the home params has been set properly
         */
        function _validHomeParams(storeId, langId) {
            //Validamos parametros
            var objToValidate = lastStoreJson;
            //Si tiene parametros, validamosd con parametros:
            if (storeId) {
                objToValidate = {
                    storeId: storeId,
                    langId: langId
                };
            }

            //SI no tiene iStoreId o iLangId  return false
            if (!objToValidate || !objToValidate.storeId || !objToValidate.langId) {
                return false;
            } else {
                return true;
            }
        }

        /**
         * @ngdoc method
         * @name setWorldWideVariables
         * @methodOf  home.service:homeManagerSvc
         * @description sets basic page auxiliary variables to render the worldwide page
         */
        function _setWorldWideVariables() {
            inditex.iPage = 'ItxWorldWidePage';
            inditex.iUrlJSON.action = 'ItxWorldWidePage';
            $('body').attr('id', 'home');
            $('html').attr('id', 'ItxWorldWidePage');
        }

        /**
         * @ngdoc method
         * @name updateWorldWideInfo
         * @methodOf  home.service:homeManagerSvc
         * @description Updates wolrdwide page info
         */
        function _updateWorldWideInfo() {
            ///inditex.iStoreId = storeId;
            //inditex.iLangId = langId;
            var deferred = $q.defer();
            //var typeCatalog = inditex.iIsMobile ? 5 : 1;
            /*var storeFound = _.find(inditex.iStoreListJSON.stores, function(storeToFind) {

                return storeToFind.id == storeId;
            });*/

            //inditex.iStoreIdentifier = 'Dutti' + storeFound.countryCode;
            //inditex.iCatalogId = storeFound.catalogs[0].id;

            //delete inditex.iCategoryTreeJSON;
            //delete inditex.iStoreJSON;
            var actions = [];
            actions.push({
                action: 'catalog:stores',
                params: {
                    brandId: inditex.iBrandId
                }
            });

            actions.push({
                action: 'akamai:location'
            });

            inditex.execute({
                actions: actions,
                onFinish: function () {
                    deferred.resolve();
                }
            });

            return deferred.promise;
        }

        /**
         * @ngdoc method
         * @name saveLastStore
         * @methodOf  home.service:homeManagerSvc
         * @description
         * Creates an object with the given params and calls setLocalStorage.
         * @param {number} storeId Id of the store. Example
         * @param {number} langId Languague ID
         * @param {string} section WOMAN, MAN OR B&G.
         */
        function saveLastStore(storeId, langId, section, saveGeoblockingStore) {
            if (storeId !== 38009450) {
                inditex.removeLocalStorage('COUNTRY_ISO');
            }
            lastStoreJson = {};
            lastStoreJson.storeId = storeId;
            lastStoreJson.langId = langId;
            lastStoreJson.saveGeoblockingStore = saveGeoblockingStore;
            if(inditex.hybridPage) {
                setLocalStorage(lastStoreJson);
            }
        }

        function setLocalStorage(lastStoreJson) {
            var isgeoBlockingEnabled = ItxConfigurationSvc.get('geoblockingEnabled');
            if (isgeoBlockingEnabled) {
                inditex.setLocalStorage('LAST_STORE_GEOBLOCKING', JSON.stringify(lastStoreJson));
                inditex.removeLocalStorage('LAST_STORE');
            } else {
                inditex.setLocalStorage('LAST_STORE', JSON.stringify(lastStoreJson));
                inditex.removeLocalStorage('LAST_STORE_GEOBLOCKING');
            }
        }

        function removeLastStore() {
            var isgeoBlockingEnabled = ItxConfigurationSvc.get('geoblockingEnabled');
            if (isgeoBlockingEnabled) {
                inditex.removeLocalStorage('LAST_STORE_GEOBLOCKING');
            } else {
                inditex.removeLocalStorage('LAST_STORE');
            }
        }
        
        /**
         * @ngdoc method
         * @name logComponentVisibilityError
         * @methodOf  home.service:homeManagerSvc
         * @description logs console descriptive errors
         * @param {object} componentData object that contains info related to the component
         * @param {string} message received to decide which message to log
         */
        function logComponentVisibilityError(componentData, message) {
            var messages = {
                cover:
                    "Visibility ERROR, element's pageName is missing!!! Please define a pagename for the component:",
                discover:
                    'Visibility ERROR, Discover element pageName is missing!!! Please define a pagename for the component:',
                link:
                    'Visibility ERROR, category link incorrect!!! Please define a valid category link for the component:',
                sliderPageName:
                    "Visibility ERROR, slider element's pageName is missing!!! Please define a pagename for every slide:",
                sliderLink:
                    'Visibility ERROR, slide link incorrect!!! Please define a valid category link for every slide:'
            };

            if (componentData) {
                console.log(messages[message]);
                console.log(componentData);
            }
        }
    }
})();
